import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ToolTip, Icon } from '@driftt/tide-core-legacy'
import cx from 'classnames'
import ConditionalRender from 'components/shared/ConditionalRender'
import GDPRMessage from '../../../GDPRMessage'
import DisconnectButton from '../../components/DisconnectButton'
import DisconnectConfirmModal from '../../components/DisconnectConfirmModal'

import withNotifications from 'components/shared/notifications'
import { fetchIntegrationStates, updateIntegrationState } from 'app/modules/integrations/actions'
import { connectionsRoot } from 'app/modules/integrations/selectors'
import { api } from './api.js'

import style from './style.styl'
const DISCONNECT_MESSAGE = (serviceName) => `${serviceName} has been successfully disconnected!`


class CommonIntegrationPage extends Component {

  constructor(props) {
    super(props)

    this.state = {
      whoIsConnected: null,
      showDisconnectModal: false,
      isDisconnecting: false,
      isIntegrationStarted: false

    }
  }

  componentDidMount = async () => {
    const { name, incompleteInstallEndpoint } = this.props
    const userInfo = await this.getConnectedUser(name)
    let whoIsConnected = undefined
    if (userInfo) {
      switch (name) {
        case 'Salesforce':
          whoIsConnected = userInfo.email
          break
        case 'Marketo':
          whoIsConnected = `Munchkin: ${userInfo.munchkinId}, ClientId: ${userInfo.clientId}`
          break
      }
    }
    let isIntegrationStarted = false
    if (incompleteInstallEndpoint) {
      const res = await this.getIncompleteState(incompleteInstallEndpoint)
      isIntegrationStarted = res.installed
    }

    this.setState({
      whoIsConnected: whoIsConnected,
      isIntegrationStarted: isIntegrationStarted
    })
  }

  getIncompleteState = (endpoint) => api.integrationAPICall(endpoint)

  getConnectedUser = (serviceName) => api.whoIsConnected(serviceName)

  showDisconnectModal = () => {
    this.setState({ showDisconnectModal: true })
  }

  hideDisconnectModal = () => {
    this.setState({ showDisconnectModal: false })
  }

  disconnect = async () => {
    const { name, integrationId, actions } = this.props

    const stopDisconnecting = () => {
      this.setState({ isDisconnecting: false })
      this.props.notifications.success(DISCONNECT_MESSAGE(name))
    }

    this.setState({ isDisconnecting: true })
    this.hideDisconnectModal()
    await actions.updateIntegrationState({ integration: integrationId, connected: false })
    stopDisconnecting()
  }

  connectionIndicator = (whoIsConnected) => {
    const { incompleteInstallEndpoint, isConnected } = this.props
    const { isIntegrationStarted } = this.state

    if (incompleteInstallEndpoint && ((!isConnected && isIntegrationStarted) || (!isIntegrationStarted && isConnected))) {
      return <div className="common-integration-page-connection-indicator common-integration-page-connection-indicator--warning">
        <Icon name="warning-triangle" />
        <span>Incomplete</span>
      </div>
    }

    return whoIsConnected ?
      <div className="common-integration-page-connection-indicator-holder">
        <ToolTip className="common-integratin-page-connection-indicator-text" component={<span>Connected to:<br/>{whoIsConnected}</span>} flow="down">
          <Icon name="check-circle" />
          <span className="common-integration-page-span">Connected!</span>
        </ToolTip>
      </div> :
      <div className="common-integration-page-connection-indicator">
        <Icon name="check-circle" />
        <span>Connected!</span>
      </div>
  }

  componentDidUpdate = async (prevProps) => {
    if (prevProps.isConnected != this.props.isConnected) {
      const { incompleteInstallEndpoint } = this.props

      if (incompleteInstallEndpoint) {
        const res = await this.getIncompleteState(incompleteInstallEndpoint)
        this.setState({
          isIntegrationStarted: res.installed
        })
      }
    }

  }

  render() {
    const { Service, logo, isConnected, serviceClassName, name, hideDisconnectButton, EduTooltip } = this.props
    return (
      <div className={cx('common-integration-page', serviceClassName)}>
        <div className="common-integration-page-notes">
          <ConditionalRender condition={EduTooltip}>
            <EduTooltip {...this.props} />
          </ConditionalRender>
          <ConditionalRender condition={isConnected}>
            {this.connectionIndicator(this.state.whoIsConnected)}
          </ConditionalRender>
        </div>
        <div className="common-integration-page-layout">
          <ConditionalRender condition={logo}>
            <div className="integration-header">
              <img src={logo} className="common-integration-page-logo" />
            </div>
          </ConditionalRender>
          <div className="common-integration-page-service">
            <Service {...this.props} />

            {(isConnected && !hideDisconnectButton) &&
              <DisconnectButton
                onClick={this.showDisconnectModal}
                isProcessing={this.state.isDisconnecting}
              />
            }

            <div className="common-integration-gdpr-message-wrapper">
              <GDPRMessage />
            </div>

            {this.state.showDisconnectModal &&
              <DisconnectConfirmModal
                integrationName={name}
                onDisconnect={this.disconnect}
                onClose={this.hideDisconnectModal}
                open={this.state.showDisconnectModal} />
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    integrationStates: connectionsRoot(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({
      fetchIntegrationStates,
      updateIntegrationState
    }, dispatch)
  }
}

export default withNotifications(
  connect(mapStateToProps, mapDispatchToProps)(CommonIntegrationPage)
)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/CommonIntegrationPage/index.js